import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export function InstallAppButton() {
  const navigate = useNavigate();
  const isMobilePhone = useIsMobile();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // Only show on mobile phones
    if (!isMobilePhone) return;

    // Check if app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowButton(false);
      return;
    }

    // Check if user dismissed the initial prompt
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed) {
      setShowButton(true);
    }
  }, [isMobilePhone]);

  if (!showButton) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={() => navigate('/install')}
            size="icon"
            className="fixed bottom-20 right-4 z-40 h-12 w-12 rounded-full shadow-lg animate-pulse hover:animate-none"
            aria-label="Install App"
          >
            <Download className="h-5 w-5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>Install App</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
